export default __webpack_public_path__ + "f77bcc98bb7468c8b15a82960c18ec63.woff2";